/* eslint-disable */
// src/utils/auth.js

import { jwtDecode } from "jwt-decode";

export function normalizeRole(role) {
  const normalized = String(role || "").trim().toLowerCase();
  return normalized === "admin" || normalized === "user" ? normalized : null;
}

export function normalizeUsername(username) {
  const normalized = String(username || "").trim();
  return normalized.length > 0 ? normalized : null;
}

export function getCurrentRole() {
  const token = localStorage.getItem("token");
  if (!token) return null;
  try {
    const decoded = jwtDecode(token);
    return normalizeRole(decoded?.role);
  } catch {
    return null;
  }
}

export function hasRoleAccess(allowedRoles) {
  if (!Array.isArray(allowedRoles) || allowedRoles.length === 0) return true;
  const currentRole = getCurrentRole();
  if (!currentRole) return false;
  const normalizedAllowed = allowedRoles.map((r) => normalizeRole(r)).filter(Boolean);
  if (normalizedAllowed.length === 0) return false;
  return normalizedAllowed.includes(currentRole);
}

export function isAdmin() {
  return getCurrentRole() === "admin";
}

export function getCurrentUsername() {
  const token = localStorage.getItem("token");
  if (!token) return normalizeUsername(localStorage.getItem("username"));

  try {
    const decoded = jwtDecode(token);
    return normalizeUsername(decoded?.username) || normalizeUsername(localStorage.getItem("username"));
  } catch {
    return normalizeUsername(localStorage.getItem("username"));
  }
}
